const READ_MORE_PREFIX = 'mplayer-read-more';

const BUTTON_ICON = 'icon';
const BUTTON_TEXT = 'button-text';

export const getButtonIconId = (playerId: string): string => `${READ_MORE_PREFIX}-${BUTTON_ICON}-${playerId}`;

export const getButtonTextId = (playerId: string): string => `${READ_MORE_PREFIX}-${BUTTON_TEXT}-${playerId}`;
